import { CSSProperties, useContext, useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";

import { AuthContext } from "../context/auth";
import { MerchantsContext } from "../context/merchants/MerchantContext";
import Message from "../components/ui/Message";

export const WelcomenPage = () => {
  const { user } = useContext(AuthContext);
  const { getWithoutITBMSConfiguration } = useContext(MerchantsContext);

  const [errorMessage, setErrorMessage] = useState("");
  const alertShownRef = useRef(false);

  const navigate = useNavigate();

  useEffect(() => {
    if (user?.groups[0]?.group_id === 3) {
      getWithoutITBMSConfiguration().then((merchants) => {
        if (merchants.length > 0 && !alertShownRef.current) {
          alertShownRef.current = true;
          setErrorMessage(
            "Hay comercios con configuración de ITBMS pendientes."
          );
        }
      });
    }
  }, []);

  const removeError = () => {
    setErrorMessage("");
  };

  return (
    <>
      <div
        className="d-flex flex-column justify-content-center align-items-center text-center"
        style={{
          minHeight: "75vh",
          padding: "3rem 1.5rem",
          background: "linear-gradient(to bottom, #ffffff, #f8f9fa)",
        }}
      >
        <div style={{ maxWidth: "720px" }}>
          {/* Saludo */}
          <h1
            style={{
              fontWeight: 600,
              fontSize: "2rem",
              letterSpacing: "-0.5px",
              marginBottom: "0.8rem",
            }}
          >
            Bienvenido{user?.name ? `, ${user.name}` : ""}
          </h1>

          {/* Título principal */}
          <p
            style={{
              fontSize: "1.3rem",
              fontWeight: 500,
              marginBottom: "1.5rem",
            }}
          >
            Portal de Onboarding
          </p>

          {/* Descripción */}
          <p
            style={{
              fontSize: "1.05rem",
              color: "#6c757d",
              lineHeight: "1.7",
              marginBottom: "2rem",
            }}
          >
            Administre sus solicitudes, consulte el estado de sus procesos
            y gestione su información desde un entorno seguro y centralizado.
          </p>

          {/* Línea decorativa */}
          <div
            style={{
              height: "1px",
              width: "60px",
              backgroundColor: "#dee2e6",
              margin: "0 auto 2rem auto",
            }}
          />

          {/* Texto secundario */}
          <p
            style={{
              fontSize: "0.95rem",
              color: "#9aa0a6",
              marginBottom: "1.5rem",
            }}
          >
            Seleccione una opción del menú para comenzar.
          </p>

          {/* Indicador sutil */}
          <p
            style={{
              fontSize: "0.85rem",
              color: "#c0c4c9",
              letterSpacing: "0.5px",
            }}
          >
            Entorno seguro · Sesión activa
          </p>
        </div>
      </div>

      {errorMessage.length > 0 && (
        <Message
          type="error"
          message={errorMessage}
          closeDialog={removeError}
          handleOk={removeError}
          backgroundColor="rgba(0,0,0,0.4)"
        />
      )}
    </>
  );
};
